import { useMemo } from 'react';

const NO_ERRORS = {};
const EFFECTIVE_DATE_FIELD = 'effectiveDate';
const ERROR_MARKER = true;

export const buildDimensionRequiredErrors = ({
  selectedDimensions,
  projectRates
}) => {
  const dimensionErrors = {};

  projectRates.forEach((rate, index) => {
    selectedDimensions.forEach(dimension => {
      const cell = rate[dimension.id];

      if (cell && !cell.value) {
        dimensionErrors[dimension.id] = {
          ...dimensionErrors[dimension.id],
          [index]: ERROR_MARKER
        };
      }
    });
  });

  return dimensionErrors;
};

export const buildEffectiveDateRequiredErrors = ({ projectRates }) => {
  const dateErrors = {};

  projectRates.forEach((rate, index) => {
    if (!rate.isInitialRate && !rate.effectiveDate) {
      dateErrors[index] = ERROR_MARKER;
    }
  });

  return dateErrors;
};

export const useProjectCostOverrideErrors = ({
  selectedDimensions,
  projectRates
}) =>
  useMemo(() => {
    const dimensionErrors = buildDimensionRequiredErrors({
      selectedDimensions,
      projectRates
    });

    const effectiveDateErrors = buildEffectiveDateRequiredErrors({
      projectRates
    });

    const projectRateErrors = {
      ...dimensionErrors,
      ...(Object.keys(effectiveDateErrors).length > 0 && {
        [EFFECTIVE_DATE_FIELD]: effectiveDateErrors
      })
    };

    const hasErrors = Object.keys(projectRateErrors).length > 0;

    return {
      errors: hasErrors ? { projectRates: projectRateErrors } : NO_ERRORS,
      hasErrors
    };
  }, [selectedDimensions, projectRates]);

export default useProjectCostOverrideErrors;
